import React from "react";
import "./check.scss";

interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  isTerms?: boolean;
  id?: string;
  className?: string;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  isTerms = false,
  id = "checkbox",
  className = "",
}) => (
  <div className={`checkbox-case ${className}`}>
    <input
      type="checkbox"
      id={id}
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      aria-label={isTerms ? "Accept Terms and Conditions" : label}
    />
    <label htmlFor={id}>
      {isTerms ? (
        <span>
          Accept{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.pluritongues.com/terms"
            className="terms-link"
          >
            Terms and Conditions
          </a>
        </span>
      ) : (
        label
      )}
    </label>
  </div>
);
